var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"cartAmount":_vm.cart.length}}),_vm._v(" "),_c('div',{staticClass:"contents"},[(_vm.cartLoaded)?_c('router-view',{attrs:{"cartMap":_vm.cartMap,"cart":_vm.cart}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad7cae02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/PhotoBuy.vue
// module id = null
// module chunks = 